/**
 * Whether a person already in the store is the directory's final answer for this viewer.
 *
 * A contact-only record (#5538) is what a network connection whose profile is not published
 * resolves to. It is not final: once the viewer shares a proposal with that person, the directory
 * answers with the whole profile (#5766). So a contact is asked about again rather than served from
 * the store, and a roster that hydrates only the people it is "missing" counts a contact as missing.
 *
 * Asking again settles. If the person is still only a contact, the answer is the same id set, which
 * RTK Query serves from its own cache, so nothing loops.
 */
export function isSettledIndividual(individual: { contactOnly?: boolean | null } | undefined): boolean {
  return !!individual && !individual.contactOnly;
}
